import { render, staticRenderFns } from "./deleteRoom.vue?vue&type=template&id=ddcf892e"
import script from "./deleteRoom.vue?vue&type=script&lang=js"
export * from "./deleteRoom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports